import { Button, Input } from "antd";
import React, { useState } from "react";
import { useRecoilState } from "recoil";
import { memberState } from "../state/atoms";
import MembersApi from "../api/MembersApi";
import { error } from "../service/MessageService";
import { LogRegLogo } from "./util/LogRegLogo";
import { env } from "../env/env";

export default function PasswordResetPage() {
  const [member] = useRecoilState(memberState);
  const [pass, setPass] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [isPassErr, setPassErr] = useState(false);

  function isValidPassword(pass: string) {
    return /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[~`*()_\-+={}[\]|:;'<>,.?/!@#$%^&*])(?=.{8,})/.test(pass);
  }

  function onPasswordChange(password: string) {
    setPass(password.trim());
    setPassErr(!isValidPassword(password.trim()));
  }

  async function submit() {
    setLoading(true);
    try {
      await MembersApi.updatePassword({
        email: member.email,
        password: pass.trim()
      });
      window.location.href = env.dashboardPath;
    } catch (ex) {
      setLoading(true);
      error("Something went wrong");
    }
  }

  return (
    <div className={"forgot-page land-page"}>
      <div className="cvr" />
      <div className={"step-password step"}>
        <LogRegLogo />
        <h2>Select a new password</h2>

        <div className={"form"}>
          <div className={"blk"}>
            <label className={"lbl"}>Enter new password</label>
            <Input.Password placeholder={"New password"} value={pass} size={"large"} onChange={ev => onPasswordChange(ev.target.value)} />
          </div>

          <div className={"blk"}>
            <label className={"lbl"}>Confirm new password</label>
            <Input.Password type={"password"} placeholder={"Confirm new password"} value={confirm} size={"large"} onChange={ev => setConfirm(ev.target.value)} />
          </div>

          <div className={'blk'} style={{marginBottom: 10, color: isPassErr ? "red" : ""}}>
            <label className={`pass ${isPassErr ? '' : ''}`}>8+ characters with a mix of letters, numbers and symbols (no \ or ").</label>
          </div>

          <Button
            size={"large"}
            className={"primary"}
            onClick={submit}
            loading={loading}
            disabled={!pass || !confirm || pass !== confirm || isPassErr}>
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
}
